<!-- component -->
<div class="dark:bg-slate-800">
    
    <!-- Hero Section - Full Height -->
    <div class="min-h-screen flex flex-col justify-center items-center px-4 sm:px-6 lg:px-8 relative overflow-hidden">
        
        <!-- Background Decorations -->
        <div class="absolute inset-0 overflow-hidden pointer-events-none">
            <div class="absolute -top-40 -right-40 w-80 h-80 bg-purple-300 dark:bg-purple-500/35 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl opacity-60 dark:opacity-40 animate-pulse"></div>
            <div class="absolute -bottom-40 -left-40 w-80 h-80 bg-indigo-300 dark:bg-indigo-400/35 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl opacity-60 dark:opacity-45 animate-pulse animation-delay-2000"></div>
            <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-pink-300 dark:bg-pink-400/30 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl opacity-50 dark:opacity-35 animate-pulse animation-delay-4000"></div>
        </div>
        
        <div class="flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-16 w-full max-w-6xl relative z-10">
            <!-- Content Section -->
            <div class="flex flex-col justify-center items-center lg:items-start gap-6 w-full lg:w-1/2 text-center lg:text-left">
                <!-- Logo and Title -->
                <div class="flex items-center justify-center lg:justify-start">
                    <img class="w-16 sm:w-20 mx-2" src="assets/logodr.png" alt="ReliefApp Logo" />  
                    <h1 class="font-mono text-3xl sm:text-4xl lg:text-5xl text-purple-500 dark:text-purple-300">ReliefApp</h1>
                </div>
                
                <!-- Subtitle -->
                <h2 class="font-mono text-lg sm:text-xl lg:text-2xl text-slate-800 dark:text-slate-200 max-w-md">
                    Un Lugar Seguro para tus Pensamientos
                </h2>
                
                <!-- CTA Button -->
                <div class="flex justify-center">
                    <a class="text-white opacity-95 flex justify-center items-center px-8 py-4 font-mono text-lg bg-gradient-to-r from-indigo-700 to-purple-300 rounded-lg hover:opacity-100 transition-opacity duration-300 w-full sm:w-auto" href="/login">
                        Comienza Ahora 
                    </a>
                </div>
                
                <!-- Privacy Link -->
                <div class="px-7 flex justify-center">
                    <app-privacy-link 
                        [linkText]="'Aviso de Privacidad'" 
                        [customClass]="'text-sm font-mono'">
                    </app-privacy-link>
                </div>
            </div>
            
            <!-- Image Section -->
            <div class="flex justify-center items-center w-full lg:w-1/2">
                <img class="w-64 sm:w-80 lg:w-96 max-w-full h-auto" src="assets/glowbad.png" alt="ReliefApp Illustration" />
            </div>
        </div>
    </div>

    <!-- About Section -->
    <section class="py-20 px-4 sm:px-6 lg:px-8">
        <div class="max-w-6xl mx-auto">
            <!-- Petriz Introduction -->
            <div class="flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-12 mb-16">
                <div class="flex-shrink-0">
                    <img class="w-48 sm:w-64 lg:w-80 rounded-full shadow-lg hover:scale-105 transition-transform duration-300" src="assets/petriz.png" alt="Petriz" />
                </div>
                <div class="text-center lg:text-left max-w-lg">
                    <h2 class="text-2xl sm:text-3xl lg:text-4xl font-mono text-slate-800 dark:text-slate-200 mb-4">
                        Hola, soy <span class="text-purple-500 dark:text-purple-300 font-semibold">Petriz</span>
                    </h2>
                    <p class="text-lg sm:text-xl font-mono text-slate-600 dark:text-slate-300">
                        Te cuento más acerca de nosotros y nuestra misión
                    </p>
                </div>
            </div>

            <!-- Mission Statement -->
            <div class="text-center max-w-4xl mx-auto mb-20">
                <h3 class="text-2xl sm:text-3xl lg:text-4xl font-mono text-slate-800 dark:text-slate-200 leading-relaxed">
                    <span class="text-purple-500 dark:text-purple-300 font-semibold">ReliefApp</span> es un sitio donde puedes desahogarte, 
                    compartir tus pensamientos de forma <span class="text-indigo-600 dark:text-indigo-400">segura</span>, 
                    almacenarlos o eliminarlos. Todo está completamente <span class="text-green-600 dark:text-green-400">encriptado</span>.
                </h3>
            </div>
        </div>
    </section>

    <!-- Features Section -->
    <section class="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50 dark:bg-slate-900 relative overflow-hidden">
        <!-- Background Decorations -->
        <div class="absolute inset-0 overflow-hidden pointer-events-none">
            <div class="absolute top-20 right-10 w-64 h-64 bg-teal-300 dark:bg-teal-400/40 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl opacity-50 dark:opacity-35 animate-pulse animation-delay-1000"></div>
            <div class="absolute bottom-20 left-10 w-72 h-72 bg-rose-300 dark:bg-rose-400/35 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl opacity-50 dark:opacity-40 animate-pulse animation-delay-3000"></div>
        </div>
        
        <div class="max-w-6xl mx-auto relative z-10">
            <h2 class="text-3xl sm:text-4xl font-mono text-center text-slate-800 dark:text-slate-200 mb-16">
                ¿Por qué elegir <span class="text-purple-500 dark:text-purple-300">ReliefApp</span>?
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <!-- Feature 1: Encryption -->
                <div class="group relative bg-white dark:bg-slate-800 rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                    <div class="text-center">
                        <div class="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                            <img class="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300" src="assets/lock2.png" alt="Encryption" />
                        </div>
                        <h4 class="font-mono text-xl text-slate-800 dark:text-slate-200 mb-4">Información Encriptada</h4>
                        <p class="text-slate-600 dark:text-slate-300 font-mono text-sm leading-relaxed">
                            Solo tú tienes acceso a tu información. Todo se encripta al momento de guardar tus pensamientos.
                        </p>
                        <div class="mt-4 text-xs text-green-600 dark:text-green-400 font-mono">
                            🔒 Nadie más puede acceder
                        </div>
                    </div>
                </div>
                <!-- Feature 2: Auto Delete -->
                <div class="group relative bg-white dark:bg-slate-800 rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                    <div class="text-center">
                        <div class="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                            <img class="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300" src="assets/glowbad.png" alt="Auto Delete" />
                        </div>
                        <h4 class="font-mono text-xl text-slate-800 dark:text-slate-200 mb-4">Auto-eliminación</h4>
                        <p class="text-slate-600 dark:text-slate-300 font-mono text-sm leading-relaxed">
                            Puedes elegir qué pensamientos deseas eliminar automáticamente en 24 horas.
                        </p>
                        <div class="mt-4 text-xs text-blue-600 dark:text-blue-400 font-mono">
                            ⏰ Control total sobre tus datos
                        </div>
                    </div>
                </div>

                <!-- Feature 3: No Ads -->
                <div class="group relative bg-white dark:bg-slate-800 rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                    <div class="text-center">
                        <div class="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                            <img class="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300" src="assets/noads.png" alt="No Ads" />
                        </div>
                        <h4 class="font-mono text-xl text-slate-800 dark:text-slate-200 mb-4">Libre de Anuncios</h4>
                        <p class="text-slate-600 dark:text-slate-300 font-mono text-sm leading-relaxed">
                            Sin interrupciones publicitarias para una experiencia pura y enfocada.
                        </p>
                        <div class="mt-4 text-xs text-purple-600 dark:text-purple-400 font-mono">
                            🚫 Nosotros también odiamos los anuncios 😉
                        </div>
                    </div>
                </div>

                <!-- Feature 4: Safe Space -->
                <div class="group relative bg-white dark:bg-slate-800 rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                    <div class="text-center">
                        <div class="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                            <img class="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300" src="assets/lluvia.png" alt="Safe Space" />
                        </div>
                        <h4 class="font-mono text-xl text-slate-800 dark:text-slate-200 mb-4">Espacio Seguro</h4>
                        <p class="text-slate-600 dark:text-slate-300 font-mono text-sm leading-relaxed">
                            Tu refugio personal para expresar libremente tus emociones y pensamientos.
                        </p>
                        <div class="mt-4 text-xs text-pink-600 dark:text-pink-400 font-mono">
                            💜 Sin juicios, solo comprensión
                        </div>
                    </div>
                </div>

                <!-- Feature 5: Community Support -->
                <div class="group relative bg-white dark:bg-slate-800 rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                    <div class="text-center">
                        <div class="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                            <img class="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300" src="assets/donaciones.png" alt="Support" />
                        </div>
                        <h4 class="font-mono text-xl text-slate-800 dark:text-slate-200 mb-4">Apoya el Proyecto</h4>
                        <p class="text-slate-600 dark:text-slate-300 font-mono text-sm leading-relaxed mb-4">
                            Proyecto mantenido con donaciones de la comunidad.
                        </p>
                        <a href="https://www.buymeacoffee.com/petrizcelaya" target="_blank" class="inline-block hover:scale-105 transition-transform duration-200">
                            <img src="assets/violet-button.png" class="w-32 mx-auto" alt="Buy me a coffee">
                        </a>
                    </div>
                </div>

                <!-- Feature 6: Coming Soon -->
                <div class="group relative bg-white dark:bg-slate-800 rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                    <div class="text-center">
                        <div class="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                            <img class="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300" src="assets/merch.png" alt="Merch" />
                        </div>
                        <h4 class="font-mono text-xl text-slate-800 dark:text-slate-200 mb-4">Merch</h4>
                        <p class="text-slate-600 dark:text-slate-300 font-mono text-sm leading-relaxed">
                            Productos oficiales de ReliefApp próximamente.
                        </p>
                        <div class="mt-4 text-xs text-orange-600 dark:text-orange-400 font-mono">
                            🚀 Próximamente disponible
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Gloria Section -->
    <section class="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
        <!-- Animated gradient decorations -->
        <div class="absolute inset-0 pointer-events-none">
            <div class="absolute -top-20 -left-20 w-96 h-96 bg-purple-300 dark:bg-purple-500/35 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl opacity-55 dark:opacity-40 animate-pulse"></div>
            <div class="absolute top-1/2 -right-32 w-80 h-80 bg-indigo-300 dark:bg-indigo-500/40 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl opacity-50 dark:opacity-45 animate-pulse" style="animation-delay: 1s;"></div>
            <div class="absolute -bottom-20 left-1/3 w-72 h-72 bg-pink-300 dark:bg-pink-500/30 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl opacity-45 dark:opacity-35 animate-pulse" style="animation-delay: 2s;"></div>
        </div>        <div class="relative max-w-6xl mx-auto">
            <div class="flex flex-col lg:flex-row-reverse justify-center items-center gap-8 lg:gap-12">
                <div class="flex-shrink-0">
                    <img class="w-48 sm:w-64 lg:w-80 rounded-full shadow-lg hover:scale-105 transition-transform duration-300" src="assets/glow.png" alt="Gloria" />
                </div>
                <div class="text-center lg:text-left max-w-lg">
                    <h2 class="text-2xl sm:text-3xl lg:text-4xl font-mono text-slate-800 dark:text-slate-200 mb-6">
                        Hola, soy <span class="text-purple-500 dark:text-purple-300 font-semibold">Gloria</span>
                    </h2>
                    <p class="text-lg sm:text-xl font-mono text-slate-600 dark:text-slate-300 leading-relaxed mb-6">
                        Este espacio es para ti. Siéntete libre de usarlo y compartirlo con alguien que lo necesite.
                    </p>
                    
                    <!-- Share Buttons -->
                    <div class="mb-6">
                        <p class="text-sm font-mono text-slate-500 dark:text-slate-400 mb-3 text-center lg:text-left">
                            Comparte ReliefApp con quien lo necesite:
                        </p>
                        <div class="flex flex-wrap justify-center lg:justify-start gap-3">
                            <!-- WhatsApp -->
                            <a href="https://wa.me/?text=Descubre%20ReliefApp%2C%20un%20lugar%20seguro%20para%20tus%20pensamientos%20%F0%9F%92%9C%20https%3A//reliefapp.org" 
                               target="_blank" 
                               class="inline-flex items-center px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-full transition-colors duration-200 shadow-md hover:shadow-lg">
                                <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.569-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.787"/>
                                </svg>
                                WhatsApp
                            </a>

                            <!-- Twitter -->
                            <a href="https://twitter.com/intent/tweet?text=Descubre%20ReliefApp%2C%20un%20lugar%20seguro%20para%20tus%20pensamientos%20%F0%9F%92%9C&url=https%3A//reliefapp.org" 
                               target="_blank" 
                               class="inline-flex items-center px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-full transition-colors duration-200 shadow-md hover:shadow-lg">
                                <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                                </svg>
                                Twitter
                            </a>

                            <!-- Facebook -->
                            <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A//reliefapp.org" 
                               target="_blank" 
                               class="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full transition-colors duration-200 shadow-md hover:shadow-lg">
                                <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                </svg>
                                Facebook
                            </a>

                            <!-- Telegram -->
                            <a href="https://t.me/share/url?url=https%3A//reliefapp.org&text=Descubre%20ReliefApp%2C%20un%20lugar%20seguro%20para%20tus%20pensamientos%20%F0%9F%92%9C" 
                               target="_blank" 
                               class="inline-flex items-center px-4 py-2 bg-blue-400 hover:bg-blue-500 text-white rounded-full transition-colors duration-200 shadow-md hover:shadow-lg">
                                <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                                </svg>
                                Telegram
                            </a>
                        </div>
                    </div>
                    
                    <div class="inline-flex items-center px-4 py-2 bg-purple-100 dark:bg-purple-900/30 rounded-full">
                        <span class="text-purple-600 dark:text-purple-300 font-mono text-sm">💜 Con amor y comprensión</span>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Footer -->
    <footer class="bg-gray-100 dark:bg-slate-900 py-8 px-4 sm:px-6 lg:px-8">
        <div class="max-w-4xl mx-auto">
            <!-- Main Footer Content -->
            <div class="text-center mb-6">
                <div class="flex items-center justify-center mb-3">
                    <img class="w-8 h-8 mr-2" src="assets/logodr.png" alt="ReliefApp Logo" />
                    <span class="font-mono text-xl text-purple-500 dark:text-purple-300">ReliefApp</span>
                </div>
                <p class="font-mono text-sm text-slate-600 dark:text-slate-300">
                    <span class="text-purple-600 dark:text-purple-300 font-mono text-sm">Creado con 💜 para <span class="text-green-500 dark:text-green-300 font-semibold">Todos</span></span>
                </p>
            </div>

            <!-- Credits -->
            <div class="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mb-6 text-center">
                <div class="flex items-center gap-1">
                    <span class="font-mono text-xs text-slate-500 dark:text-slate-400">Desarrollo:</span>
                    <a href="https://twitter.com/petrizcelaya" target="_blank" class="font-mono text-sm text-purple-600 dark:text-purple-400 hover:text-purple-800 dark:hover:text-purple-200 transition-colors">
                        @PetrizCelaya
                    </a>
                </div>
                <div class="flex items-center gap-1">
                    <span class="font-mono text-xs text-slate-500 dark:text-slate-400">Arte:</span>
                    <a href="https://twitter.com/glowferuz" target="_blank" class="font-mono text-sm text-purple-600 dark:text-purple-400 hover:text-purple-800 dark:hover:text-purple-200 transition-colors">
                        @GlowFeRuz
                    </a>
                </div>
            </div>

            <!-- Privacy Link -->
            <div class="text-center border-t border-gray-300 dark:border-slate-700 pt-4">
                <app-privacy-link 
                    [linkText]="'Aviso de Privacidad'" 
                    [customClass]="'text-xs font-mono text-slate-500 dark:text-slate-400 hover:text-purple-600 dark:hover:text-purple-400 transition-colors'">
                </app-privacy-link>
            </div>
        </div>
    </footer>

</div>
